<template>
  <div class="warp">
    <!-- <audio controls id="playerVideo">
      <source :src="playerUrl" type="audio/mpeg">
    </audio> -->
    <img src="~assets/image/mq.jpg" alt="" style="width: 70%; display: block; margin: 0 auto;">
    <div class="btnSubmit">
      <van-button :disabled="isdis" @click="speak1()" round block type="info">开始面签</van-button>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      speech: null,
      isdis: false,
      playerUrl:  ''
    }
  },
  mounted() {
    this.speechInit();
  },
  methods: {
    speak1() {
      this.playerUrl.play();
      this.isdis = true;

      this.playerUrl.addEventListener('ended', () => {
        this.$router.push('/examine/index')
        this.isdis = false
      })
    },
    speechInit() {
      this.api.voice({
        code: window.localStorage.getItem('code') || ''
      }).then(res => {
        if(res.code == 200) {
          const configuredOrigin = process.env.VUE_APP_API_ORIGIN;
          const apiOrigin = configuredOrigin && configuredOrigin !== '/'
            ? configuredOrigin.replace(/\/+$/, '')
            : window.location.origin;
          const audioUrl = new URL(res.url, `${apiOrigin}/`).toString();
          this.playerUrl = new Audio(audioUrl);
        } else {
          this.$toast.fail(res.msg);
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.warp {
  width: 100vw;
  height: 100vh;
  background: #fff;
}

.btnSubmit {
  width: 80%;
  margin: 0 auto;
  margin-top: 40px;
}
</style>
